import { MailOpen } from 'lucide-react';
import { Fragment } from 'react';

import { Button } from '@/components/ui/button';

import { InvitationDialogLayout } from './InvitationDialogLayout';

type Props = {
  onClose: () => void;
  goToEscrow: () => void;
};

export function InvitationAccepted({ onClose, goToEscrow }: Props) {
  return (
    <InvitationDialogLayout
      icon={<MailOpen />}
      title="This invitation has already been accepted"
      description="You're already a member of this escrow. No further action is needed."
      footer={
        <Fragment>
          <Button data-testid="accepted-close-btn" variant="outline" onClick={onClose}>
            Close
          </Button>
          <Button onClick={goToEscrow}>Go to escrow</Button>
        </Fragment>
      }
    />
  );
}
